const defaultBtn = {
  backgroundColor: '#4E4E4E',
  backgroundColorHover: '#1b1b1b',
  color: '#FFF',
  colorHover: '#FFF',
};

const defaultInverseBtn = {
  backgroundColor: '#FFF',
  backgroundColorHover: '#4e4e4e',
  color: '#4E4E4E',
  colorHover: '#FFF',
};

const dangerBtn = {
  backgroundColor: '#D50021',
  backgroundColorHover: '#AF0000',
  color: '#FFF',
  colorHover: '#FFF',
};

const dangerInverseBtn = {
  backgroundColor: '#FFF',
  backgroundColorHover: '#AF0000',
  color: '#D50021',
  colorHover: '#FFF',
};

const primaryBtn = {
  backgroundColor: 'var(--primary-color)',
  backgroundColorHover: 'var(--primary-color-hover)',
  color: '#FFF',
  colorHover: '#FFF',
};

const primaryInverseBtn = {
  backgroundColor: '#FFF',
  backgroundColorHover: 'var(--primary-color-hover)',
  color: 'var(--primary-color)',
  colorHover: '#FFF',
};

const pinkBtn = {
  backgroundColor: '#FF0079',
  backgroundColorHover: '#F00073',
  color: '#FFF',
  colorHover: '#FFF',
};

const pinkInverseBtn = {
  backgroundColor: '#FFF',
  backgroundColorHover: '#FFF',
  color: '#FF007A',
  colorHover: '#F00073',
};

const actionBtn = {
  backgroundColor: '#FF6A8E',
  backgroundColorHover: '#FFDAEB',
  color: '#FFF',
  colorHover: '#FFF',
};

const actionInverseBtn = {
  backgroundColor: '#FFF',
  backgroundColorHover: '#FFF',
  color: '#FF6A8E',
  colorHover: '#FFDAEB',
};

const secondaryBtn = {
  backgroundColor: '#FF007A',
  backgroundColorHover: '#f00073',
  color: '#FFF',
  colorHover: '#FFF',
};

const secondaryInverseBtn = {
  backgroundColor: '#fff',
  backgroundColorHover: '#f00073',
  color: '#FF007A',
  colorHover: '#FFF',
};

const successBtn = {
  backgroundColor: '#428bca',
  backgroundColorHover: '#2a6496',
  color: '#FFF',
  colorHover: '#FFF',
};

const successInverseBtn = {
  backgroundColor: '#FFF',
  backgroundColorHover: '#2a6496',
  color: '#428bca',
  colorHover: '#FFF',
};

const warningBtn = {
  backgroundColor: '#F5A623',
  backgroundColorHover: '#c37d09',
  color: '#FFF',
  colorHover: '#FFF',
};

const warningInverseBtn = {
  backgroundColor: '#FFF',
  backgroundColorHover: '#c37d09',
  color: '#F5A623',
  colorHover: '#FFF',
};

export default function getStyles(
  color: 'danger' | 'default' | 'pink' | 'primary' | 'secondary' | 'success' | 'warning' | 'action',
  isInverse: boolean
) {
  switch (color) {
    case 'danger':
      return isInverse ? dangerInverseBtn : dangerBtn;

    case 'pink':
      return isInverse ? pinkInverseBtn : pinkBtn;

    case 'primary':
      return isInverse ? primaryInverseBtn : primaryBtn;

    case 'secondary':
      return isInverse ? secondaryInverseBtn : secondaryBtn;

    case 'success':
      return isInverse ? successInverseBtn : successBtn;

    case 'warning':
      return isInverse ? warningInverseBtn : warningBtn;

    case 'action':
      return isInverse ? actionInverseBtn : actionBtn;

    default:
      return isInverse ? defaultInverseBtn : defaultBtn;
  }
}
